import { render } from "./PricePerUnit.vue?vue&type=template&id=60ca0ee0"
import script from "./PricePerUnit.vue?vue&type=script&lang=js"
export * from "./PricePerUnit.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__